import path from 'path'

import _ from 'lodash'
import { createSelector } from 'reselect'

import { MESH_EXTENSIONS } from '~/lib/cadExtensions'

export const grabAndLowerExt = file => {
    return path.extname(file.name).toLowerCase()
}

export const getMeshExts = createSelector(_.identity, files => {
    return files.filter(file => {
        return MESH_EXTENSIONS.includes(grabAndLowerExt(file))
    })
})
